/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { TViewComponent } from "../../../view/IView";
import { IframeView } from "./IframeView";

export const IframeViewComponent: TViewComponent<IframeView> = ({ view }) => {
	const baseClass = BEM("edt-viewiframe");

	return <iframe src={view.getUrl()} className={baseClass.toClassName()}></iframe>;
};
